import {
  AttachFile,
  CheckCircle,
  Close,
  DateRange,
  DeleteOutline,
  Edit,
  HelpOutline,
  Link,
  MoreVert,
  ArchiveOutlined,
} from "@material-ui/icons";
import "bootstrap-daterangepicker/daterangepicker.css";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { ErrorMessage, Field, Form, Formik } from "formik";
import htmlToDraft from "html-to-draftjs";
import $ from "jquery";
import moment from "moment";
import "moment-timezone";
import React from "react";
import { Button, Col, Dropdown, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Dropzone from "react-dropzone";
import { Mention, MentionsInput } from "react-mentions";
import { connect } from "react-redux";
import * as Yup from "yup";
import { GetDependencytasksAction } from "../../../actions/MasterTemplateActions";
import { getVarriableRefAction } from "../../../actions/TransactionActions";
import defaultStyle from "../../MasterTemplate/defaultStyle";
import {
  addDocAction,
  deleteDocFromTaskAction,
  listDocAction,
  updateDocAction,
  uploadDocumentAction,
  documentNotificationAction,
  removeDocumentAction,
} from "./../../../actions/DocActions";
import {
  addCommentAction,
  deleteCommentAction,
  getActualValuesAction,
  getTaskDetailsAction,
  updateDepedentTaskAction,
  updateTaskAction,
  getSpecialTaskAction,
  getVendorSpecialAppoTasksAction,
} from "./../../../actions/TransactionActions";
import DependancyIcon from "./../../../assets/img/dependancy-icon.svg";
import UrlConstants from "./../../../config/UrlConstants";
import ReactSelect from "react-select";
import SetDependency from "./set-dependency";
import {
  cryptoTokenDecode,
  getTimeFromMins,
  formatPhoneNumber,
  getTimeFormat,
  getMinutes,
  toastMessage,
  convertTZ,
} from "./../../Common/Common";
import DeletePrompt from "./../../Common/DeletePrompt";
import { getallpermissions } from "../../../actions/UserActions";
import * as code from "./../../../config/Constants";
import * as message from "./../../../config/CommonMessages";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
var CryptoJS = require("crypto-js");

var _ = require("lodash");

class TaskDetail extends React.Component {
  submitMyForm = null;
  myRef = React.createRef();
  constructor(props) {
    super(props);
    let userType = cryptoTokenDecode().usertype;
    let currentType = cryptoTokenDecode().roleName;
    this.state = {
      show: false,
      startDate: moment(),
      closeDate: moment().subtract(-29, "days"),
      taskType: "Communication",
      showText: true,
      taskData: {},
      editEmailTo: false,
      editcommunicationDesctription: false,
      editcommunicationSubject: false,
      emailRefVar: [],
      variablesRefs: [],
      textRefVar: [],
      AllRefVarForMapping: [],
      AllRefVar: [],
      emailTextValForEditor: EditorState.createEmpty(),
      actualEmailTextValForEditor: EditorState.createEmpty(),
      detailsValForEditor: EditorState.createEmpty(),
      actualValues: {},
      showLoader: false,
      contingencies: [],
      comments: [],
      comment: "",
      DependencyModal: false,
      docName: "",
      showPreview: false,
      previewURL: "",
      dependencyIsActive: false,
      archivePrompt: false,
      deletePrompt: false,
      userType: userType.toUpperCase(),
      values: {},
      deleteDocName: "",
      deleteCommentPrompt: false,
      moveConfirmationModal: false,
      affectedTasks: [],
      moveTaskPostData: {},
      moveErrorMessage: "",
      moveErrorModal: false,
      assigneeOptions: [
        {
          label: "select",
          value: "",
        },
      ],
      editAssignee: false,
      tokens: "",
      disableAll: false,
      isDocumentRequired: false,
      specialTask: [],
      specialtaskforinterativeEventType: [],
      specialtaskforCommunicativeEventType: [],
      statusChangeShow: false,
      isTaskCompleted: false,
      statusVal: "",
      statusFieldVal: "",
      selectedVal: "",
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      isTaskTypeDisable: false,
      permissionArray: [],
    };

    this.deleteComment = this.deleteComment.bind(this);
  }

  // show task detail
  editTask = (i) => {
    if (i === 0) {
      this.setState({ editTask: "open" });
    } else {
      this.props.onUpdate("");
    }
  };

  closeModal(e) {
    this.setState({
      DependencyModal: !this.state.DependencyModal,
    });
    this.getTasksDetails();
  }

  DependencyModal(vals, actiontaken) {
    if (vals) {
      let day = vals.day;
      let event = vals._id;
      let selectedTransaction = vals.transactionId;
      this.props
        .GetDependencytasksAction(
          selectedTransaction,
          day,
          event,
          "TRANSACTION"
        )
        .then((res) => {
          if (res.status === code.OK) {
            this.setState({
              DependencyModal: !this.state.DependencyModal,
              dependencyTasks: this.props.dependencyTasks,
              actiontaken,
            });
          }
        });
    } else {
      this.setState({ DependencyModal: !this.state.DependencyModal });
    }
  }

  addComment = () => {
    let commentdata = {
      content: this.state.comment,
    };
    this.setState({ comment: "" });
    this.props.addCommentAction(commentdata, this.props.taskId).then((res) => {
      this.getNewComments();
    });
  };

  /**
   * @desc delete comment by id
   */
  deleteComment(cid) {
    let commentId = {
      commentId: cid,
    };
    this.props.deleteCommentAction(this.props.taskId, commentId).then((res) => {
      this.getNewComments();
      this.setState({ deleteCommentPrompt: false });
    });
  }

  getNewComments() {
    this.getTasksDetails();
  }

  handleChange(e) {
    this.setState({ comment: e.target.value });
  }

  showTaskType(e) {
    if (e + "".toUpperCase() === "COMMUNICATION") {
      this.setState({ taskType: true });
      this.setState({
        specialTask: this.state.specialtaskforCommunicativeEventType,
      });
    } else {
      this.setState({ taskType: false });
      this.setState({
        specialTask: this.state.specialtaskforinterativeEventType,
      });
    }
  }

  /**
   * @desc clear communicationd data, to,subject, desc
   * @param {*} setErrors
   */
  clearCommunication(setErrors) {
    var dateStr = moment().format("YYYY-MM-DD");
    var timeStr = getTimeFormat(540);

    var taskData = this.state.taskData;
    taskData.communicationTo = [""];
    taskData.communicationSubject = [""];
    taskData.description = [""];
    taskData.isReminder = false;
    taskData.reminderDate = new Date(dateStr + " " + timeStr);
    taskData.reminderTime = 480;

    this.setState({ actualValues: {} });
    this.setState(
      { taskData },
      () => {
        this.getEditorContent(this.state.taskData);
      },
      () => {
        setErrors({});
      }
    );
    setErrors({});
  }

  // Communication Type condition
  showText(e) {
    if ((e + "").toUpperCase() === "EMAIL") {
      this.setState({ showText: true });
    } else {
      this.setState({ showText: false });
    }
  }
  componentWillMount() {
    this.setState({ showLoader: true });
    var contingencies = this.props.transactionData.contingencies;
    this.setState({ contingencies });
    this.getTasksDetails();
    this.getSpecialTasks();
  }

  bindSubmitForm = (submitForm) => {
    this.submitMyForm = submitForm;
  };
  /**
   * @desc get special task
   */
  getSpecialTasks() {
    this.props.getSpecialTaskAction().then((res) => {
      if (res.status === code.OK) {
        // this.setState({ specialTask: this.props.specialTask });
        let specialtaskforinterativeEventType = this.props.specialTask;

        let specialtaskforCommunicativeEventTypevariable = this.props.specialTask.filter(
          (obj) => obj.name !== "Appointment"
        );
        // console.log(
        //   "specialtaskforCommunicativeEventType",
        //   specialtaskforCommunicativeEventTypevariable
        // );

        this.setState({
          specialTask: specialtaskforCommunicativeEventTypevariable,
          specialtaskforCommunicativeEventType: specialtaskforCommunicativeEventTypevariable,
          specialtaskforinterativeEventType: this.props.specialTask,
        });
      }
    });
  }

  /**
   * @desc get task details by id
   */
  getTasksDetails() {
    this.setState({ showloader: true });
    this.props.getTaskDetailsAction(this.props.taskId).then((res) => {
      this.setState({ showloader: false });
      if (res) {
        if (
          this.props.transactionData.status === "COMPLETED" ||
          res.status === "COMPLETED"
        ) {
          this.setState({
            disableAll: true,
          });
        }
        if (
          res.type !== undefined &&
          res.type !== "" &&
          res.type === "INTERACTIVE"
        ) {
          this.setState({ isTaskTypeDisable: true });
        }

        this.getVariables().then((r) => {
          let assigneeOptions = [];
          this.state.variablesRefs.forEach((v) => {
            if (res.contingency !== undefined && res.contingency !== "") {
              if (
                (v.contingency === "all" ||
                  v.contingency === res.contingency) &&
                v.account === "user"
              ) {
                assigneeOptions.push({ label: v.name, value: v.name });
              }
            } else {
              if (v.account === "user") {
                assigneeOptions.push({ label: v.name, value: v.name });
              }
            }
          });
          this.setState({
            assigneeOptions,
          });
        });
        let comments = res.comments || [];
        this.setState({ comments });
        let commStr = "";
        let commToArray = [];
        var communicationTo = res.communicationTo.filter(function(i) {
          return i !== "";
        });
        communicationTo.forEach((e, i, v) => {
          if (e) {
            if (e.toString().indexOf("@") == 0) {
              //bind {{}} for showing data from mension input
              commStr += "{(" + e + ")}" + (i < v.length - 1 ? ", " : "");
              commToArray.push(e);
            } else {
              if (res.communicationType == "TEXT") {
                let num = e.includes("-") ? e : formatPhoneNumber(e);
                commStr += num + (i < v.length - 1 ? ", " : "");
                commToArray.push(num);
              } else {
                commStr += e + (i < v.length - 1 ? ", " : "");
                commToArray.push(e);
              }
            }
          }
        });

        res.communicationTo[0] = commStr;

        res.communicationSubject.forEach((e, i, v) => {
          if (e) {
          }
        });
        res.communicationTo[0] = commStr;

        //reminder date and flag
        var dateStr = moment(res.eventEndDate).format("YYYY-MM-DD");
        var timeStr = getTimeFormat(540);

        res.isReminder = !!res.isReminder ? res.isReminder : false;
        res.reminderDate = !!res.reminderDate
          ? res.reminderDate
          : new Date(dateStr + " " + timeStr);
        res.reminderTime = !!res.reminderTime ? res.reminderTime : 480;
        res.reminderTime = !!res.reminderTime ? res.reminderTime : 480;

        res.specialTask = !!res.specialTask ? res.specialTask : [];

        res.eventEndDate = new Date(
          moment(res.eventEndDate).format("MM/DD/YYYY h:mm:ss")
        );
        res.eventStartDate = new Date(
          moment(res.eventStartDate).format("MM/DD/YYYY h:mm:ss")
        );
        this.setState({ showloader: true });
        this.props.getActualValuesAction(this.props.taskId).then((res1) => {
          var commStr1 = "";
          var noValues = [];
          var tokens = "";
          if (!!res1 && !!res1.communicationTo) {
            let communicationToArr = res1.communicationTo.filter(function(i) {
              return i != "";
            });

            let newCommToAr = [];
            communicationToArr.forEach((e, i, v) => {
              if (Array.isArray(e)) {
                e.forEach((ev, iv, vv) => {
                  newCommToAr.push(ev);
                });
              } else {
                newCommToAr.push(e);
              }
            });
            newCommToAr.forEach((e, i, v) => {
              if (e != "" && e != null && e != undefined) {
                if (res.communicationType == "TEXT") {
                  if (e.toString().indexOf("@") == 0) {
                    commStr1 += e + (i < v.length - 1 ? ", " : "");
                  } else {
                    commStr1 +=
                      formatPhoneNumber(e) + (i < v.length - 1 ? ", " : "");
                  }
                } else {
                  commStr1 += e + (i < v.length - 1 ? ", " : "");
                }
              } else {
                noValues.push(commToArray[i]);
              }
            });
          }
          _.uniq(noValues).forEach((e, i, v) => {
            if (e) {
              tokens +=
                e.replace(/\{\(/g, "").replace(/\)\}/g, "") +
                (i < v.length - 1 ? ", " : "");
            }
          });
          res1.communicationSubject[0] = !!res1.communicationSubject[0]
            ? (res1.communicationSubject[0] + "")
                .replace(/\{\(/g, "")
                .replace(/\)\}/g, "")
            : "";
          res1.communicationTo[0] = commStr1;
          this.setState({ actualValues: res1, tokens, showLoader: false });
          this.setState({ showloader: false });
          var actualEmailTextValForEditor = EditorState.createEmpty();
          if (
            res1.description &&
            res1.description.length > 0 &&
            !!res1.description[0]
          ) {
            let contentBlock = htmlToDraft(res1.description[0]);
            if (contentBlock) {
              const contentState = ContentState.createFromBlockArray(
                contentBlock.contentBlocks
              );
              actualEmailTextValForEditor = EditorState.createWithContent(
                contentState
              );
            }
          }
          this.setState({ actualEmailTextValForEditor });
        });
        this.setState({ taskData: res, showLoader: false }, () => {
          this.getEditorContent(this.state.taskData);
        });
        if (res.predecessorData.length > 0) {
          this.setState({ dependencyIsActive: true });
        }
        this.showTaskType((res.type + "").toUpperCase());
        this.showText((res.communicationType + "").toUpperCase());
      } else {
        this.setState({ showLoader: false });
      }
    });
  }

  closeErrorModal() {
    this.setState({ moveErrorModal: false });
    this.getTasksDetails();
    this.props.onUpdate("update");
  }

  closeStatusChangeModal() {
    this.setState({
      statusChangeShow: false,
      statusVal: "",
      statusFieldVal: "",
      selectedVal: "",
    });
  }

  /**
   * @desc get variables
   */
  async getVariables() {
    this.setState({ showLoader: true });
    await this.props
      .getVarriableRefAction(this.props.transactionData._id)
      .then((res) => {
        this.setState({ showLoader: false });
        var emailRefVar = [];
        var textRefVar = [];
        var AllRefVar = [];
        var AllRefVarForMapping = [];
        var AllRefVarForEditor = [];
        var variablesRefs = res || [];

        for (var i = 0, len = variablesRefs.length; i < len; i++) {
          if (variablesRefs[i].account !== "user") {
            AllRefVar.push({
              id: variablesRefs[i].name,
              display: variablesRefs[i].name,
            });

            AllRefVarForMapping.push(variablesRefs[i].name);

            AllRefVarForEditor.push({
              text: variablesRefs[i].name,
              value: variablesRefs[i].name.replace("@", ""),
              url: "",
            });
          }

          if (variablesRefs[i].communicationtype === "EMAIL") {
            emailRefVar.push({
              id: variablesRefs[i].name,
              display: variablesRefs[i].name,
            });
          }
          if (variablesRefs[i].communicationtype === "TEXT") {
            textRefVar.push({
              id: variablesRefs[i].name,
              display: variablesRefs[i].name,
            });
          }
        }
        this.setState({
          variablesRefs,
          emailRefVar: emailRefVar,
          textRefVar: textRefVar,
          AllRefVar: AllRefVar,
          AllRefVarForEditor: AllRefVarForEditor,
          AllRefVarForMapping: AllRefVarForMapping,
        });
      });
  }

  /**
   * @desc get editor content
   * @param {*} values
   */
  getEditorContent(values) {
    var emailTextValForEditor = EditorState.createEmpty();
    var detailsValForEditor = EditorState.createEmpty();

    if (
      values.description &&
      values.description.length > 0 &&
      !!values.description[0]
    ) {
      let contentBlock = htmlToDraft(values.description[0]);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        emailTextValForEditor = EditorState.createWithContent(contentState);
      }
    }

    if (values.type.toUpperCase() === "INTERACTIVE") {
      let contentBlock = htmlToDraft(
        values.description &&
          (values.description.length > 0 && values.description[0])
      );
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        detailsValForEditor = EditorState.createWithContent(contentState);
      }
    }

    this.setState({ emailTextValForEditor, detailsValForEditor });
  }

  /**
   * @desc update task details
   * @param {*} values
   * @param {*} setFieldValue
   * @param {*} field
   * @param {*} value
   * @param {*} edit
   */
  updateTask(values, setFieldValue, field, value, edit) {
    this.myRef.current.setSubmitting();
    this.submitMyForm();

    var val = values;
    val["valueChanged"] = field;
    if (field == "communicationTo" || field == "communicationSubject") {
      setFieldValue(field, value, true);
      val[field] = value;

      if (edit == "save") {
        if (Object.keys(this.myRef.current.state.errors).length <= 0) {
          this.handleSubmit(val);
        }
      }
    } else if (field == "description") {
      if (edit == "save") {
        if (Object.keys(this.myRef.current.state.errors).length <= 0) {
          this.handleSubmit(val);
        }
      }
    } else if (field == "status") {
      val[field] = value;
      if (this.myRef.current.state.values.document == true) {
        if (this.myRef.current.state.values.documents.length > 0) {
          setFieldValue(field, value, true);
          if (Object.keys(this.myRef.current.state.errors).length <= 0) {
            this.handleSubmit(val);
          }
        } else {
          this.setState({ isDocumentRequired: true });
        }
      } else {
        setFieldValue(field, value, true);
        if (Object.keys(this.myRef.current.state.errors).length <= 0) {
          this.handleSubmit(val);
        }
      }
    } else if (field == "contingency") {
      val[field] = value;
      setFieldValue(field, value, true);
      if (value) {
        this.handleSubmit(val);
      }
    } else {
      val[field] = value;
      setFieldValue(field, value, true);
      if (Object.keys(this.myRef.current.state.errors).length <= 0) {
        this.handleSubmit(val);
      }
    }
  }

  /**
   * @desc toggle assignee data with actual value
   * @param {*} values
   * @param {*} setFieldValue
   * @param {*} value
   * @param {*} edit
   */
  toggleAssignee(values, setFieldValue, value, edit) {
    this.updateTask(values, setFieldValue, "assignee", value, edit);
    if (value != "" || this.state.editAssignee == false) {
      this.setState({ editAssignee: !this.state.editAssignee });
    }
  }

  /**
   * @desc toggle communicationTo data with actual value
   * @param {*} values
   * @param {*} setFieldValue
   * @param {*} value
   * @param {*} edit
   */
  toggleCommunicationTo(values, setFieldValue, value, edit) {
    this.updateTask(values, setFieldValue, "communicationTo", value, edit);
    if (value[0] != "" || this.state.editEmailTo == false) {
      this.setState({ editEmailTo: !this.state.editEmailTo });
    }
  }

  /**
   * @desc toggle communicationSubject data with actual value
   * @param {*} values
   * @param {*} setFieldValue
   * @param {*} value
   * @param {*} edit
   */
  toggleCommunicationSubject(values, setFieldValue, value, edit) {
    this.updateTask(values, setFieldValue, "communicationSubject", value, edit);
    if (value[0] != "" || this.state.editcommunicationSubject == false) {
      this.setState({
        editcommunicationSubject: !this.state.editcommunicationSubject,
      });
    }
  }

  /**
   * @desc task date change
   */
  confirmMove() {
    this.setState({ moveConfirmationModal: false, showLoader: true });
    this.props
      .updateDepedentTaskAction(
        this.state.taskData._id,
        this.state.moveTaskPostData
      )
      .then((res) => {
        this.setState({ showLoader: false });
        this.getTasksDetails();
        this.props.onUpdate("update");
      });
  }

  /**
   * @desc toggle decription data
   * @param {*} values
   * @param {*} setFieldValue
   * @param {*} value
   * @param {*} edit
   */
  toggleDescription(values, setFieldValue, value, edit) {
    if (edit == "cancel") {
      setFieldValue("description", this.state.taskData.description);
      this.getEditorContent(this.state.taskData);
    } else {
      this.updateTask(values, setFieldValue, "description", value, edit);
    }
    if (
      value[0] != "<p></p>\n" ||
      this.state.editcommunicationDesctription == false
    ) {
      this.setState({
        editcommunicationDesctription: !this.state
          .editcommunicationDesctription,
      });
    }
  }

  /**
   * @desc update task data
   * @param {*} values
   */
  handleSubmit(values) {
    var val = values;
    val.eventType = val.type;

    if (val.type == "COMMUNICATION" && val.communicationType == "") {
      val.communicationType = "EMAIL";
    }

    if (val.communicationType == "TEXT") {
      for (let i = 0; i < val.communicationTo.length; i++) {
        val.communicationTo[i] = val.communicationTo[i]
          .toString()
          .replace(/\-/g, "");
      }
    }
    var commToVal = [];
    if (val.communicationTo) {
      //replacing {{ and }} as it comes with mention selection
      (val.communicationTo + "").split(/[,]+/).forEach((e) => {
        var data = e.replace(/\{\(/g, "").replace(/\)\}/g, "") || "";
        commToVal.push(data.trim());
      });
    }

    val.communicationTo = [...new Set(commToVal)]; // get unique values
    //console.log('val.communicationTo ',val.communicationTo);

    if (val.communicationType == "TEXT") {
      if (val.description) {
        //replacing {{ and }} as it comes with mention selection
        val.description = [
          (val.description[0] + "").replace(/\{\(/g, "").replace(/\)\}/g, ""),
        ];
      }
    }

    if (
      val["valueChanged"] == "eventEndDate" ||
      val["valueChanged"] == "time"
    ) {
      val["time"] =
        moment(val.eventStartDate).hour() * 60 +
        moment(val.eventStartDate).minute();
    }
    if (
      val["valueChanged"] == "eventStartDate" ||
      val["valueChanged"] == "time"
    ) {
      val["time"] =
        moment(val.eventStartDate).hour() * 60 +
        moment(val.eventStartDate).minute();
    }
    //Add local timezone offset to request
    var d = new Date();
    val.timeZone = d.getTimezoneOffset().toString();

    delete val["eventLogs"];
    delete val["commentsLogs"];
    this.setState({ showLoader: true });
    /** update  assignee if  value of assignee is SYSTEM */
    if (val.eventType === "INTERACTIVE" && val.assignee === "SYSTEM") {
      val.assignee = "@buyer_agent";
    }
    this.props.updateTaskAction(val, this.state.taskData._id).then((res) => {
      this.setState({ showLoader: false });
      if (res != undefined && res.length > 0) {
        var affectedTasks = res || [];
        this.setState({
          moveConfirmationModal: true,
          affectedTasks,
          moveTaskPostData: val,
        });
      } else {
        if (res != undefined && res.hasOwnProperty("message")) {
          this.setState({
            moveErrorModal: true,
            moveErrorMessage: res.message,
          });
        } else {
          if (
            val["valueChanged"] == "eventEndDate" ||
            val["valueChanged"] == "time"
          ) {
            this.setState({ showLoader: true });
            this.props
              .updateDepedentTaskAction(this.state.taskData._id, val)
              .then((res) => {
                this.setState({ showLoader: false });
                this.getTasksDetails();
                this.props.onUpdate("update");
              });
          }
          if (
            val["valueChanged"] == "eventStartDate" ||
            val["valueChanged"] == "time"
          ) {
            this.setState({ showLoader: true });
            this.props
              .updateDepedentTaskAction(this.state.taskData._id, val)
              .then((res) => {
                this.setState({ showLoader: false });
                this.getTasksDetails();
                this.props.onUpdate("update");
              });
          } else {
            this.getTasksDetails();
            this.props.onUpdate("update");
          }
        }
      }
    });
  }

  /**
   * @desc event date change change format and set to data also check selected time and bind it to date
   */
  handleStartDateChange(date, type, setFieldValue, values) {
    // update end date as start date forcefully
    this.handleEndDateChange(date, "date", setFieldValue, values);

    let dateStr = moment().format("YYYY-MM-DD");
    if (date) {
      dateStr = moment(date).format("YYYY-MM-DD");
      var timeStr = moment(date).format("HH:mm");
    } else {
      dateStr = moment().format("YYYY-MM-DD");
      timeStr = moment().format("HH:mm");
    }
    if (type == "time") {
      dateStr = moment(values.eventStartDate).format("YYYY-MM-DD");
    }

    var finalDate = moment(dateStr + " " + timeStr);
    var timeStamp = new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"));
    var formatedDate = moment(timeStamp.getTime()).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    if (values.isReminder) {
      //get reminder date time for comparison
      var reminderDate = moment(values.reminderDate).format(
        "YYYY-MM-DDTHH:mm:ssZ"
      );
      let diff = moment(finalDate).isAfter(reminderDate);
      if (diff) {
        this.setState({ errMsg: undefined });
        this.updateTask(
          values,
          setFieldValue,
          "eventStartDate",
          new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"))
        );
      } else {
        this.setState({
          errMsg:
            "Please select due date time after selected reminder date time.",
        });
      }
    } else {
      this.setState({ errMsg: undefined });
      // this.updateTask(values, setFieldValue, 'eventEndDate', new Date(finalDate.format('YYYY-MM-DDTHH:mm:ssZ')));
      this.updateTask(
        values,
        setFieldValue,
        "eventStartDate",
        moment
          .tz(
            formatedDate,
            "YYYY-MM-DDTHH:mm:ssZ",
            this.props.transactionData.userTimezone
          )
          .utc()
          .format()
      );
    }
  }

  handleEndDateChange(date, type, setFieldValue, values) {
    let dateStr = moment().format("YYYY-MM-DD");
    if (date) {
      dateStr = moment(date).format("YYYY-MM-DD");
      var timeStr = moment(date).format("HH:mm");
    } else {
      dateStr = moment().format("YYYY-MM-DD");
      timeStr = moment().format("HH:mm");
    }
    if (type == "time") {
      dateStr = moment(values.eventEndDate).format("YYYY-MM-DD");
    }

    var finalDate = moment(dateStr + " " + timeStr);
    var timeStamp = new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"));
    var formatedDate = moment(timeStamp.getTime()).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    if (values.isReminder) {
      //get reminder date time for comparison
      var reminderDate = moment(values.reminderDate).format(
        "YYYY-MM-DDTHH:mm:ssZ"
      );
      let diff = moment(finalDate).isAfter(reminderDate);
      if (diff) {
        this.setState({ errMsg: undefined });
        this.updateTask(
          values,
          setFieldValue,
          "eventEndDate",
          new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"))
        );
      } else {
        this.setState({
          errMsg:
            "Please select due date time after selected reminder date time.",
        });
      }
    } else {
      this.setState({ errMsg: undefined });
      // this.updateTask(values, setFieldValue, 'eventEndDate', new Date(finalDate.format('YYYY-MM-DDTHH:mm:ssZ')));
      this.updateTask(
        values,
        setFieldValue,
        "eventEndDate",
        moment
          .tz(
            formatedDate,
            "YYYY-MM-DDTHH:mm:ssZ",
            this.props.transactionData.userTimezone
          )
          .utc()
          .format()
      );
    }
  }

  /**
   * @desc upload attachment
   * @param {*} e
   * @param {*} id
   * @param {*} transId
   * @param {*} values
   */
  uploadAttchments(e, id, transId, values) {
    this.setState({ showLoader: true });
    var formData = new FormData();
    var documents = [];
    var docDetail = {};

    this.setState({ showLoader: true });
    if (e.length > 0) {
      for (var i = 0; i < e.length; i++) {
        docDetail = {
          fileName: e[i].name,
          size: (e[i].size / (1024 * 1024)).toFixed(2),
        };
        documents.push(docDetail);
        formData.append("file", e[i]);
      }

      var dataToPost = {
        transactionId: transId,
        location: "Transaction Docs",
        transactionEventId: id,
        document: documents,
      };
      this.setState({ showLoader: true });
      this.props.addDocAction(dataToPost).then(
        (res) => {
          this.setState({ showLoader: false });
          if (res.status === code.OK) {
            this.setState({ showLoader: true });
            var fileUploadName = "";
            res.data.map((item) => {
              if (fileUploadName.length > 0) {
                fileUploadName +=
                  "@@@" + item.document + "###" + item.uploadedFileName;
              } else {
                fileUploadName = item.document + "###" + item.uploadedFileName;
              }
            });
            this.props
              .uploadDocumentAction(formData, transId, id, fileUploadName)
              .then(
                (res) => {
                  this.setState({ showLoader: false });
                  this.props.documentNotificationAction(transId, id);
                  this.getTasksDetails();
                  this.props.onUpdate("update");
                },
                (error) => {
                  this.setState({ showLoader: false });
                }
              );
          } else {
            toastMessage(code.ERROR, res.data);
          }
        },
        (error) => {
          this.setState({ showLoader: false });
        }
      );
    } else {
      this.setState({ showLoader: false });
    }
  }

  /**
   * @desc show document preview
   * @param {*} name
   */
  showPreviewModal(name) {
    if (name) {
      var url = "/#";
      fetch(
        UrlConstants.AdminCreateTransactionUrl +
          "/" +
          name +
          "?id=" +
          this.props.transactionData._id,
        { method: "GET" }
      )
        .then((response) => response.json())
        .then((res) => {
          url = res.url;
          this.setState({ showPreview: true, docName: name, previewURL: url });
        });
    }
  }
  /**
   * @desc gettype of file
   * @param {*} name
   */
  getType(name) {
    var type = "";
    var ext = ((name.match(/(\.\w+$)/gim) || [])[0] + "").toLowerCase();
    if (ext == ".jpg" || ext == ".jpeg" || ext == ".png" || ext == ".gif") {
      type = "image";
    } else if (name.match(/.(pdf)$/i)) {
      type = "pdf";
    }
    return type;
  }

  /**
   * @desc archive docmuent
   * @param {*} folderId
   * @param {*} values
   */
  archiveDocument(folderId, values) {
    var dataToPut = {
      folderId: folderId,
    };
    this.setState({
      showLoader: true,
    });
    this.props.deleteDocFromTaskAction(dataToPut, values._id).then((res) => {
      this.setState({ showLoader: false });
      this.archivePrompt();
      this.getTasksDetails();
      this.props.onUpdate("update");
    });
  }

  /**
   * @desc open archive promt
   * @param {*} id
   * @param {*} values
   */
  archivePrompt(id, values) {
    if (IDBDatabase && values) {
      this.setState({
        archivePrompt: !this.state.archivePrompt,
        values: values,
        deleteDocName: id,
      });
    } else {
      this.setState({
        archivePrompt: !this.state.archivePrompt,
      });
    }
  }
  /**
   * @desc api call for delete document
   */
  deleteDocument() {
    this.setState({
      showLoader: true,
    });
    this.props.removeDocumentAction(this.state.deleteDocName).then((res) => {
      this.setState({ showLoader: false });
      this.deletePrompt();
      this.getTasksDetails();
      this.props.onUpdate("update");
    });
  }
  /**
   * @desc open delete promt
   * @param {*} id
   * @param {*} values
   */
  deletePrompt(id) {
    if (id) {
      this.setState({
        deletePrompt: !this.state.deletePrompt,
        deleteDocName: id,
      });
    } else {
      this.setState({
        deletePrompt: !this.state.deletePrompt,
      });
    }
  }
  /**
   * @desc action to handle reminder date change - change format and set to data also check selected time and bind it to date
   */
  handleReminerDateChange(date, type, setFieldValue, values) {
    let dateStr = moment().format("YYYY-MM-DD");
    if (date) {
      dateStr = moment(date).format("YYYY-MM-DD");
      var timeStr = moment(date).format("HH:mm");
    } else {
      dateStr = moment().format("YYYY-MM-DD");
      timeStr = moment().format("HH:mm");
    }

    if (type == "time") {
      dateStr = moment(values.reminderDate).format("YYYY-MM-DD");
    }

    var finalDate = moment(dateStr + " " + timeStr);
    var timeStamp = new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"));
    var formatedDate = moment(timeStamp.getTime()).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    //this.updateTask(values, setFieldValue, 'reminderDate', new Date(finalDate.format('YYYY-MM-DDTHH:mm:ssZ')));
    this.updateTask(
      values,
      setFieldValue,
      "reminderDate",
      moment
        .tz(
          formatedDate,
          "YYYY-MM-DDTHH:mm:ssZ",
          this.props.transactionData.userTimezone
        )
        .utc()
        .format()
    );
  }
  //returns true/false depends on user role(vendor/buyer)
  canUserEdit() {
    return (
      this.state.disableAll ||
      ((this.state.userType === message.VENDOR &&
        this.state.currentRole === message.VENDOR) ||
      this.state.userType === message.BUYER
        ? true
        : false)
    );
  }
  checkPermission(checkFor) {
    const hasSome =
      this.state.permissionArray &&
      this.state.permissionArray.length > 0 &&
      checkFor.some((item) => this.state.permissionArray.includes(item));
    return hasSome;
  }

  checkViewAppoPermission() {
    // console.log('in checkViewAppoPermission ========>');
    // console.log('state permission',this.state.permissionArray);
    //vendor has view appo permission but not manage appointment
    // console.log('view_appointments',this.state.permissionArray.includes(message.view_appointments));
    // console.log('manage_appointments',!this.state.permissionArray.includes(message.manage_appointments));
    let cond1 =
      this.state.permissionArray.includes(message.view_appointments) &&
      !this.state.permissionArray.includes(message.manage_appointments)
        ? true
        : false;

    // console.log('cond1',cond1);

    this.props.getVendorSpecialAppoTasksAction().then((res) => {
      let cond2 = res.data && res.data.includes(this.props.taskId); // check current event is of vendor or not

      //console.log('cond2',cond2);

      if (this.state.userType === message.VENDOR && cond1 && !cond2) {
        //console.log('disabling status from check view permission');
        this.setState({
          disableAll: true,
        });
      }
    });
  }

  componentDidMount() {
    this.getUserPermissions();
    // console.log("hello123", this.state.userType);
    if (this.state.userType === message.ADMIN) {
      this.setState({
        disableAll: true,
      });
    }
  }
  getUserPermissions() {
    let usertype = localStorage.getItem("usertype");
    // console.log("currentRole", this.state.currentRole);
    // console.log("currentType", this.state.userType);
    if (this.state.userType === "VENDOR") {
      this.props.getallpermissions().then((res) => {
        if (res.data) {
          localStorage.setItem("otherInfo", res.data);
          this.setState({ permission: res.data });
          let bytes = CryptoJS.AES.decrypt(
            res.data,
            REACT_APP_CRYPTO_SECRET_KEY
          );
          let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          // console.log("Header ===> decryptedData39", decryptedData);
          let permissionarray = decryptedData.split(",");
          // console.log("task details ===> permissionarray", permissionarray);
          // console.log(
          //   "Header ===>this.props.permission",
          //   this.props.permissiontype
          // );
          // checking permission on props, because this component is reused 4 address.
          if (!permissionarray.includes(this.props.permissiontype)) {
            // so there is no permissions, hence disabling all feilds.
            // console.log("Header ===> there is no permission");
            // this.setState({
            //   disableAll: true,
            // });
          }
          this.setState({ permissionArray: permissionarray });

          if (this.state.currentRole === "CLIENT") {
            // console.log("hello i am here");
            this.setState({
              disableAll: true,
            });
          }
          if (
            this.state.currentRole === "ARTIST" &&
            (this.props.fromAppoCalendar !== undefined &&
              this.props.fromAppoCalendar)
          ) {
            this.checkViewAppoPermission();
          }
        }
      });
    }
  }

  checkTaskDetails() {
    if (this.state.disableAll && this.state.currentRole !== "CLIENT") {
      return true;
    } else {
      if (this.state.taskData.type === "INTERACTIVE") {
        if (this.state.taskData.document) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }

  render() {
    let specialTaskArr = this.state.taskData.specialTask;
    // let isActive = localStorage.getItem("isActive");
    var tEndDate = this.props.transactionData.endDate || "";
    var addTaskValidation = Yup.object().shape({
      title: Yup.string().required(message.ENTER_TASK_TITLE),
      contingency: Yup.string().required(message.SELECT_CONTINGENCY),
      type: Yup.string().required(message.SELECT_TASK_TYPE),
      description: Yup.array()
        .nullable()
        .test("description", message.ENTER_DESCRIPTION, (values) => {
          if (values[0] == "<p></p>\n" || values[0] == "") {
            return false;
          }
          return true;
        }),
    });

    if (this.state.showText) {
      addTaskValidation = Yup.object().shape({
        title: Yup.string().required(message.ENTER_TASK_TITLE),
        contingency: Yup.string().required(message.SELECT_CONTINGENCY),
        communicationTo: Yup.array()
          .nullable()
          .test(
            "email",
            this.state.showText
              ? message.ENTER_VALID_RICIPIENT
              : message.ENTER_TEXT_RECIPIENT,
            (values) => {
              if (values[0] == "") {
                return false;
              }
              return true;
            }
          )
          .test("email", message.ENTER_VALID_EMAIL, (values) => {
            if (values) {
              var valid = false;
              (values[0] + "")
                .trim()
                .split(/[ ,]+/)
                .forEach((e) => {
                  var data = e.replace(/\{\(/g, "").replace(/\)\}/g, "") || "";
                  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                  if (data.trim().indexOf("@") == 0 || data.length == 0) {
                    valid = true;
                  } else {
                    if ((data.trim().match(mailformat) || []).length > 0) {
                      valid = true;
                    } else {
                      valid = false;
                    }
                  }
                });
              return valid;
            }
          }),
        communicationSubject: Yup.array()
          .nullable()
          .test("subject", message.ENTER_SUBJECT, (values) => {
            if (values[0] == "") {
              return false;
            }
            return true;
          }),
        description: Yup.array()
          .nullable()
          .test("description", message.ENTER_DESCRIPTION, (values) => {
            if (values[0] == "<p></p>\n" || values[0] == "") {
              return false;
            }
            return true;
          }),
      });
    }

    if (!this.state.showText) {
      addTaskValidation = Yup.object().shape({
        title: Yup.string().required(message.ENTER_TASK_TITLE),
        contingency: Yup.string().required(message.SELECT_CONTINGENCY),
        communicationTo: Yup.array()
          .nullable()
          .test("phone", message.ENTER_TEXT_RECIPIENT, (values) => {
            if (values[0] == "") {
              return false;
            }
            return true;
          })
          .test(
            "phone",
            "Please enter valid Phone Number, e.g 999-999-9999.",
            (values) => {
              if (values) {
                var valid = false;
                (values[0] + "")
                  .trim()
                  .split(/[,]+/)
                  .forEach((e) => {
                    var data =
                      e.replace(/\{\(/g, "").replace(/\)\}/g, "") || "";
                    var phoneformat = /(?:1?|\+1|\+\s1|\(?)(?:\(?|\s\(|[\.\-\s])\d{3}(?:\)?|\)\s|[\.\-\s])\d{3}[\.\-\s]\d{4}/g;
                    if (data.trim().indexOf("@") == 0) {
                      valid = true;
                    } else {
                      if ((data.trim().match(phoneformat) || []).length > 0) {
                        valid = true;
                      } else {
                        valid = false;
                      }
                    }
                  });
                return valid;
              }
            }
          ),
        description: Yup.array()
          .nullable()
          .test("description", message.ENTER_DESCRIPTION, (values) => {
            if (values[0] == "<p></p>\n" || values[0] == "") {
              return false;
            }
            return true;
          }),
      });
    }

    if (!this.state.taskType) {
      addTaskValidation = Yup.object().shape({
        title: Yup.string().required(message.ENTER_TASK_TITLE),
        contingency: Yup.string().required(message.SELECT_CONTINGENCY),
        eventType: Yup.string().required(message.SELECT_TASK_TYPE),
        assignee: Yup.string().required(message.SELECT_ASIGNEE),
        description: Yup.array()
          .nullable()
          .test("description", message.ENTER_DESCRIPTION, (values) => {
            if (values == "<p></p>\n" || values == "") {
              return false;
            }
            return true;
          }),
      });
    }
    const config = {
      fontColor: {
        colors: [
          {
            color: "hsl(0, 0%, 0%)",
            label: "Black",
          },
          {
            color: "hsl(0, 0%, 30%)",
            label: "Dim grey",
          },
          {
            color: "hsl(0, 0%, 60%)",
            label: "Grey",
          },
          {
            color: "hsl(0, 0%, 90%)",
            label: "Light grey",
          },
          {
            color: "hsl(0, 0%, 100%)",
            label: "White",
            hasBorder: true,
          },
        ],
      },
      fontBackgroundColor: {
        colors: [
          {
            color: "hsl(0, 75%, 60%)",
            label: "Red",
          },
          {
            color: "hsl(30, 75%, 60%)",
            label: "Orange",
          },
          {
            color: "hsl(60, 75%, 60%)",
            label: "Yellow",
          },
          {
            color: "hsl(90, 75%, 60%)",
            label: "Light green",
          },
          {
            color: "hsl(120, 75%, 60%)",
            label: "Green",
          },
        ],
      },
      toolbar: [
        "bold",
        "strike",
        "italic",
        "link",
        "bulletedList",
        "numberedList",
        "blockQuote",
        "fontColor",
        "fontBackgroundColor",
      ],
      heading: {
        options: [
          {
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph",
          },
          {
            model: "heading1",
            view: "h1",
            title: "Heading 1",
            class: "ck-heading_heading1",
          },
          {
            model: "heading2",
            view: "h2",
            title: "Heading 2",
            class: "ck-heading_heading2",
          },
        ],
      },
    };

    return (
      <div>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}

        <Formik
          ref={this.myRef}
          validateOnBlur={true}
          initialValues={this.state.taskData}
          enableReinitialize={true}
          validationSchema={addTaskValidation}
          onEvent={() => {}}
          onSubmit={(values) => {}}
        >
          {(formikProps) => {
            const {
              errors,
              values,
              handleBlur,
              setFieldValue,
              submitForm,
              touched,
              setErrors,
            } = formikProps;

            // bind the submission handler remotely
            this.bindSubmitForm(submitForm);
            return (
              <Form autocomplete="off">
                <Row className="mx-0 task-title-row">
                  <Col className="d-flex align-items-center">
                    <h5 className="font-14 color-blue-4 mb-0">Task Name</h5>
                  </Col>
                  <Col className="col-auto task-schedule">
                    <Row className="align-items-center">
                      <Col className="col-auto pr-0">
                        <h5 className="font-14 color-blue-4 mb-0">Status</h5>
                      </Col>
                      <Col className="col-auto px-0">
                        <div
                          className="c-select"
                          disabled={
                            values.type == "COMMUNICATION" ? true : false
                          }
                        >
                          <select
                            name="status"
                            value={values.status}
                            disabled={
                              this.state.disableAll ||
                              (values.type == "COMMUNICATION" ? true : false)
                            }
                            className="form-control form-control-sm"
                            onChange={(e) => {
                              if (e.target.value === "COMPLETED") {
                                this.setState({
                                  statusVal: values,
                                  statusFieldVal: setFieldValue,
                                  selectedVal: e.target.value,
                                });
                                this.setState({ statusChangeShow: true });
                              }
                            }}
                          >
                            <option value="SCHEDULED">Scheduled</option>
                            <option value="COMPLETED">Completed</option>
                          </select>
                        </div>
                      </Col>
                      <Col className="col-auto px-0 dependency-combo">
                        <Row className="align-items-center mx-0">
                          {(this.state.userType === message.VENDOR &&
                            this.state.currentRole === message.VENDOR) ||
                          this.state.userType === message.BUYER ? (
                            ""
                          ) : (
                            <>
                              <Col className="col-auto px-0">
                                {this.state.dependencyIsActive ? (
                                  <Button
                                    variant="transparent"
                                    className="pl-1 pr-0 dep-btn"
                                    title="Check Dependency"
                                    onClick={() =>
                                      this.DependencyModal(values, "UPDATE")
                                    }
                                  >
                                    <img
                                      src={DependancyIcon}
                                      style={{ height: "24px", width: "24px" }}
                                      alt="dependency"
                                    />
                                  </Button>
                                ) : (
                                  ""
                                )}
                              </Col>
                              {!this.state.disableAll && (
                                <Col className="col-auto px-0">
                                  <Dropdown
                                    alignRight
                                    className="task-action dropdown-action"
                                  >
                                    <Dropdown.Toggle
                                      variant="transparent"
                                      id="dropdown-basic"
                                      className="p-0"
                                    >
                                      <MoreVert />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      {!this.state.dependencyIsActive && (
                                        <Dropdown.Item
                                          onClick={() =>
                                            this.DependencyModal(values, "ADD")
                                          }
                                        >
                                          Set Dependency{" "}
                                          <Link style={{ height: "20px" }} />
                                        </Dropdown.Item>
                                      )}
                                      {(this.state.userType ===
                                        message.VENDOR &&
                                        this.state.currentRole ===
                                          message.VENDOR) ||
                                      this.state.userType === message.BUYER ? (
                                        ""
                                      ) : (
                                        <Dropdown.Item
                                          onClick={() => {
                                            // if (isActive === "false") {
                                            //   toastMessage(
                                            //     code.ERROR,
                                            //     "Your subscription is not active, Please activate to continue."
                                            //   );
                                            // } else {
                                            //   this.props.deleteTask(
                                            //     this.props.taskId
                                            //   );
                                            // }

                                            this.props.deleteTask(
                                              this.props.taskId
                                            );
                                          }}
                                        >
                                          Delete task
                                        </Dropdown.Item>
                                      )}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </Col>
                              )}
                            </>
                          )}
                        </Row>
                      </Col>

                      <Col className="col-auto px-0 hide-991">
                        <div className="text-right">
                          <Button
                            onClick={() => {
                              this.editTask(1);
                              if (
                                this.props.fromTimeline !== undefined &&
                                this.props.fromTimeline
                              ) {
                                this.props.closeDetailsModal();
                              }
                            }}
                            variant="transparent"
                            className="pl-0"
                          >
                            <Close />
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="12" className="task-head-name">
                    <Field
                      name="title"
                      className={"task-add-input form-control field_ucfirst"}
                      placeholder="Write task here"
                      value={values.title}
                      disabled={this.canUserEdit()}
                      onBlur={(e) => {
                        this.updateTask(
                          values,
                          setFieldValue,
                          "title",
                          e.target.value
                        );
                      }}
                    />
                    <ErrorMessage
                      name="title"
                      component="div"
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    />
                  </Col>
                </Row>

                {(this.state.userType === message.VENDOR &&
                  this.state.currentRole === message.VENDOR) ||
                this.state.userType === message.BUYER ? (
                  ""
                ) : (
                  <Row className="mx-0 mt-2">
                    <Col xs="12" sm="4">
                      <h5 className="font-14 color-blue-4">Contingency</h5>
                      <div className="c-select">
                        <select
                          name="contingency"
                          id=""
                          className="form-control form-control-xs"
                          value={values.contingency}
                          disabled={this.state.disableAll}
                          onChange={(e) => {
                            this.updateTask(
                              values,
                              setFieldValue,
                              "contingency",
                              e.target.value
                            );
                          }}
                        >
                          <option value="">Select</option>
                          {this.state.contingencies.map((e) => {
                            return (
                              <option key={e.name} value={e.name}>
                                {e.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <ErrorMessage
                        name="contingency"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </Col>
                  </Row>
                )}
                {(this.state.userType === message.VENDOR &&
                  this.state.currentRole === message.VENDOR) ||
                this.state.userType === message.BUYER ? (
                  ""
                ) : (
                  <Row className="mx-0 mt-2 mb-3">
                    <Col xs="12" sm="4">
                      <h5 className="font-14 color-blue-4">Task Type</h5>
                      <div className="c-select">
                        <select
                          name=""
                          id=""
                          value={values.type}
                          className="form-control form-control-xs"
                          disabled={
                            this.state.disableAll ||
                            this.state.isTaskTypeDisable
                          }
                          onChange={(e) => {
                            this.updateTask(
                              values,
                              setFieldValue,
                              "type",
                              e.target.value
                            );
                            this.showTaskType(e.target.value);
                          }}
                        >
                          <option value="COMMUNICATION">Communication</option>
                          <option value="INTERACTIVE">Interactive</option>
                        </select>
                      </div>
                      <ErrorMessage
                        name="type"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </Col>
                    {this.state.taskType ? (
                      ""
                    ) : (
                      <Col xs="12" sm="4">
                        <h5 className="font-14 color-blue-4">Special Task</h5>
                        <div className="c-select">
                          <select
                            name="specialTask"
                            component="select"
                            value={values.specialTask}
                            className="form-control form-control-xs"
                            disabled={
                              this.state.disableAll ||
                              this.state.isTaskTypeDisable
                            }
                            onChange={(e) => {
                              this.updateTask(
                                values,
                                setFieldValue,
                                "specialTask",
                                [e.target.value]
                              );
                            }}
                          >
                            <option value="">Select</option>
                            {this.state.specialTask.map((e) => {
                              return (
                                <option key={e.name} value={e.value}>
                                  {e.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </Col>
                    )}
                  </Row>
                )}

                <Row className="mx-0 my-3 date-block-wrapper align-items-center">
                  <Col className="due-date-block pr-0 col-auto">
                    <div className="task-date-row mb-3">
                      <div className="icon-wrapper blue-wrapper task-date">
                        <div className="react-bootstrap-daterangepicker-container">
                          <div className="date-label">
                            <span className="form-control-icn">
                              <DateRange />
                            </span>
                            {specialTaskArr !== undefined &&
                            specialTaskArr.includes("Paperwork") ? (
                              <span className="form-control-label">Due:</span>
                            ) : (
                              <span className="form-control-label mb-5">
                                Start:
                              </span>
                            )}
                          </div>
                          {values.contingency != undefined &&
                          values.contingency != "" ? (
                            <DatePicker
                              selected={convertTZ(
                                values.eventStartDate,
                                this.props.transactionData.userTimezone
                              )}
                              // selected={values.eventStartDate}
                              onChange={(date) =>
                                this.handleStartDateChange(
                                  date,
                                  "date",
                                  setFieldValue,
                                  values
                                )
                              }
                              dateFormat="MM-d-yyyy"
                              className="form-control form-control-sm pl-1 date-picker"
                              minDate={new Date()}
                              disabled={this.canUserEdit()}
                            />
                          ) : (
                            <DatePicker
                              selected={convertTZ(
                                values.eventStartDate,
                                this.props.transactionData.userTimezone
                              )}
                              // selected={values.eventStartDate}
                              onChange={(date) =>
                                this.handleStartDateChange(
                                  date,
                                  "date",
                                  setFieldValue,
                                  values
                                )
                              }
                              dateFormat="MM-d-yyyy"
                              className="form-control form-control-sm pl-1 date-picker"
                              disabled={this.canUserEdit()}
                              minDate={new Date()}
                            />
                          )}
                          {specialTaskArr !== undefined &&
                          specialTaskArr.includes("Paperwork") ? (
                            ""
                          ) : (
                            <DatePicker
                              selected={convertTZ(
                                values.eventStartDate,
                                this.props.transactionData.userTimezone
                              )}
                              // selected={values.eventStartDate}
                              onChange={(date) =>
                                this.handleStartDateChange(
                                  date,
                                  "time",
                                  setFieldValue,
                                  values
                                )
                              }
                              showTimeSelect
                              showTimeSelectOnly
                              // minTime={
                              //   values.type
                              //     ? new Date(new Date().setHours(8, 0, 0, 0))
                              //     : ""
                              // }
                              // maxTime={
                              //   values.type
                              //     ? new Date(new Date().setHours(21, 0, 0, 0))
                              //     : ""
                              // }
                              timeIntervals={30}
                              timeCaption="Time"
                              dateFormat="h:mm aa"
                              className="form-control time-task ml-3 form-control-sm pl-1"
                              disabled={this.canUserEdit()}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>

                  {specialTaskArr !== undefined &&
                  specialTaskArr.includes("Paperwork") ? (
                    ""
                  ) : (
                    <Col className="due-date-block pr-0 col-auto">
                      <div className="task-date-row mb-3">
                        <div className="icon-wrapper blue-wrapper task-date">
                          <div className="react-bootstrap-daterangepicker-container">
                            <div className="date-label">
                              <span className="form-control-icn">
                                <DateRange />
                              </span>
                              <span className="form-control-label">End:</span>
                            </div>
                            {values.contingency != undefined &&
                            values.contingency != "" ? (
                              <DatePicker
                                selected={convertTZ(
                                  values.eventEndDate,
                                  this.props.transactionData.userTimezone
                                )}
                                // selected={values.eventStartDate}
                                onChange={(date) =>
                                  this.handleEndDateChange(
                                    date,
                                    "date",
                                    setFieldValue,
                                    values
                                  )
                                }
                                dateFormat="MM-d-yyyy"
                                className="form-control form-control-sm pl-1 date-picker"
                                disabled={true}
                                minDate={new Date()}
                              />
                            ) : (
                              <DatePicker
                                selected={convertTZ(
                                  values.eventEndDate,
                                  this.props.transactionData.userTimezone
                                )}
                                // selected={values.eventStartDate}
                                onChange={(date) =>
                                  this.handleEndDateChange(
                                    date,
                                    "date",
                                    setFieldValue,
                                    values
                                  )
                                }
                                dateFormat="MM-d-yyyy"
                                className="form-control form-control-sm pl-1 date-picker"
                                disabled={true}
                                minDate={new Date()}
                              />
                            )}
                            <DatePicker
                              selected={convertTZ(
                                values.eventEndDate,
                                this.props.transactionData.userTimezone
                              )}
                              // selected={values.eventEndDate}
                              onChange={(date) =>
                                this.handleEndDateChange(
                                  date,
                                  "time",
                                  setFieldValue,
                                  values
                                )
                              }
                              showTimeSelect
                              showTimeSelectOnly
                              // minTime={
                              //   values.type
                              //     ? new Date(new Date().setHours(8, 0, 0, 0))
                              //     : ""
                              // }
                              // maxTime={
                              //   values.type
                              //     ? new Date(new Date().setHours(21, 0, 0, 0))
                              //     : ""
                              // }
                              timeIntervals={30}
                              timeCaption="Time"
                              dateFormat="h:mm aa"
                              className="form-control time-task ml-3 form-control-sm pl-1"
                              disabled={this.canUserEdit()}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}

                  {this.state.errMsg !== undefined && (
                    <div
                      className="invalid-feedback px-3"
                      style={{ display: "block" }}
                    >
                      {this.state.errMsg}
                    </div>
                  )}
                </Row>

                {this.state.taskType ? (
                  // task communication
                  <div style={{ backgroundColor: "#f8f8f8" }}>
                    <Row className="mx-0 bg-blue-5 py-2 mb-2">
                      <Col xs="12">
                        <h5 className="font-14 color-blue-4 mb-1">
                          Communication Type
                        </h5>
                        <div className="form-group mb-0">
                          {(values.communicationType + "").toUpperCase() ==
                          "EMAIL" ? (
                            <div className="custom-control custom-radio custom-radio-sm custom-control-inline">
                              <input
                                name="communicationType"
                                type="radio"
                                className="custom-control-input"
                                id="check1"
                                disabled
                                value="EMAIL"
                                onChange={(e) => {
                                  this.showText(e.target.value);
                                  this.clearCommunication(setErrors);
                                  this.updateTask(
                                    values,
                                    setFieldValue,
                                    "communicationType",
                                    "EMAIL",
                                    setErrors
                                  );
                                  setErrors({});
                                }}
                                checked={
                                  values.communicationType === "EMAIL"
                                    ? "checked"
                                    : ""
                                }
                              />

                              <label
                                className="custom-control-label"
                                htmlFor="check1"
                                style={{ color: "black" }}
                              >
                                Email
                              </label>
                            </div>
                          ) : (
                            <div className="custom-control custom-radio custom-radio-sm custom-control-inline">
                              <input
                                name="communicationType"
                                type="radio"
                                className="custom-control-input"
                                id="check2"
                                disabled
                                value="TEXT"
                                onChange={(e) => {
                                  this.showText(e.target.value);
                                  this.clearCommunication(setErrors);
                                  this.updateTask(
                                    values,
                                    setFieldValue,
                                    "communicationType",
                                    "TEXT",
                                    setErrors
                                  );
                                  setErrors({});
                                }}
                                checked={
                                  values.communicationType === "TEXT"
                                    ? "checked"
                                    : ""
                                }
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="check2"
                                style={{ color: "black" }}
                              >
                                Text
                              </label>
                            </div>
                          )}
                        </div>
                        <ErrorMessage
                          name="communicationType"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </Col>
                    </Row>
                    <Row className="mx-0 mail-row">
                      <Col className="col-auto pr-0">
                        <h5 className="font-14 color-blue-4 mb-0">To</h5>
                      </Col>

                      <Col className="mail-row-field mail-row-field-regular mail-row-field-opts">
                        {this.state.editEmailTo == true ? (
                          <MentionsInput
                            singleLine
                            name="communicationTo[0]"
                            type="text"
                            value={
                              values.communicationTo
                                ? values.communicationTo[0]
                                : ""
                            }
                            className={
                              "mail-row-mension " +
                              (errors.communicationTo &&
                              errors.communicationTo[0] &&
                              (touched.communicationTo &&
                                touched.communicationTo[0])
                                ? " is-invalid"
                                : "")
                            }
                            onChange={(e) => {
                              setFieldValue("communicationTo", [
                                e.target.value,
                              ]);
                            }}
                            style={defaultStyle}
                          >
                            <Mention
                              trigger="@"
                              appendSpaceOnAdd={true}
                              data={
                                this.state.showText
                                  ? this.state.emailRefVar
                                  : this.state.textRefVar
                              }
                              markup="{(__id__)}"
                            />
                          </MentionsInput>
                        ) : (
                          <Field
                            type="text"
                            disabled
                            className="form-control font-14 color-yellow-1 mb-0 email-input"
                            value={
                              !!this.state.actualValues.communicationTo
                                ? !!this.state.actualValues
                                    .communicationTo[0] &&
                                  this.state.actualValues.communicationTo[0] !==
                                    "undefined"
                                  ? this.state.actualValues.communicationTo[0]
                                  : ""
                                : ""
                            }
                          />
                        )}
                        {!this.state.disableAll && (
                          <>
                            {this.state.editEmailTo == true ? (
                              <Button
                                variant="transparent"
                                className="edit-opt"
                                onClick={() => {
                                  this.toggleCommunicationTo(
                                    values,
                                    setFieldValue,
                                    values.communicationTo,
                                    "save"
                                  );
                                }}
                              >
                                <CheckCircle className="" />
                              </Button>
                            ) : (
                              <Button
                                variant="transparent"
                                className="edit-opt"
                                onClick={() => {
                                  this.toggleCommunicationTo(
                                    values,
                                    setFieldValue,
                                    values.communicationTo,
                                    errors.communicationTo,
                                    ""
                                  );
                                }}
                              >
                                <Edit className="" />
                              </Button>
                            )}
                          </>
                        )}
                        {this.state.tokens.length > 0 &&
                          this.state.editEmailTo == false && (
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              The {this.state.tokens} has not been set on this
                              transaction.
                            </div>
                          )}
                        <ErrorMessage
                          name="communicationTo"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </Col>
                    </Row>
                    {this.state.showText ? (
                      <div>
                        <hr className="mt-2 mb-2" />
                        <Row className="mx-0 mail-row">
                          <Col className="col-auto pr-0">
                            <h5 className="font-14 color-blue-4 mb-0">
                              Subject
                            </h5>
                          </Col>
                          <Col className="mail-row-field mail-row-field-opts">
                            {this.state.editcommunicationSubject == true ? (
                              <MentionsInput
                                singleLine
                                name="communicationSubject[0]"
                                type="text"
                                value={
                                  !!values.communicationSubject &&
                                  !!values.communicationSubject[0]
                                    ? values.communicationSubject[0]
                                    : ""
                                }
                                className={
                                  "mail-row-mension " +
                                  (errors.communicationSubject &&
                                  errors.communicationSubject[0] &&
                                  (touched.communicationSubject &&
                                    touched.communicationSubject[0])
                                    ? " is-invalid"
                                    : "")
                                }
                                onChange={(e) => {
                                  setFieldValue("communicationSubject", [
                                    e.target.value,
                                  ]);
                                }}
                                style={defaultStyle}
                              >
                                <Mention
                                  trigger="@"
                                  appendSpaceOnAdd={true}
                                  data={this.state.AllRefVar}
                                  markup="{(__id__)}"
                                />
                              </MentionsInput>
                            ) : (
                              <Field
                                type="text"
                                disabled
                                className="form-control font-14 color-yellow-1 mb-0 email-input"
                                value={
                                  !!this.state.actualValues
                                    .communicationSubject &&
                                  this.state.actualValues.communicationSubject
                                    .length > 0
                                    ? !!this.state.actualValues
                                        .communicationSubject[0] &&
                                      this.state.actualValues
                                        .communicationSubject[0] !== "undefined"
                                      ? this.state.actualValues
                                          .communicationSubject[0]
                                      : ""
                                    : ""
                                }
                              />
                            )}
                            {!this.state.disableAll && (
                              <>
                                {this.state.editcommunicationSubject == true ? (
                                  <Button
                                    variant="transparent"
                                    className="edit-opt"
                                    onClick={() => {
                                      this.toggleCommunicationSubject(
                                        values,
                                        setFieldValue,
                                        values.communicationSubject,
                                        "save"
                                      );
                                    }}
                                  >
                                    <CheckCircle className="" />
                                  </Button>
                                ) : (
                                  <Button
                                    variant="transparent"
                                    className="edit-opt"
                                    onClick={() => {
                                      this.toggleCommunicationSubject(
                                        values,
                                        setFieldValue,
                                        values.communicationSubject,
                                        ""
                                      );
                                    }}
                                  >
                                    <Edit className="" />
                                  </Button>
                                )}
                              </>
                            )}

                            {(this.state.actualValues.communicationSubject
                              ? this.state.actualValues
                                  .communicationSubject[0] + ""
                              : ""
                            ).trim() == "" &&
                              this.state.editcommunicationSubject == false && (
                                <div
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                >
                                  {" "}
                                  No values entered for this token
                                </div>
                              )}
                            <ErrorMessage
                              name="communicationSubject"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                    <hr className="mt-2" />

                    <Row className="mx-0 align-items-center pb-3">
                      {this.state.showText ? (
                        <Col xs="12">
                          <div className="editor-main">
                            {this.state.editcommunicationDesctription ==
                            true ? (
                              <Editor
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                                mention={{
                                  separator: " ",
                                  trigger: "@",
                                  suggestions: this.state.AllRefVarForEditor,
                                }}
                                toolbar={{
                                  options: [
                                    "inline",
                                    "list",
                                    "link",
                                    "blockType",
                                  ],
                                  inline: {
                                    inDropdown: false,
                                    options: ["bold", "italic"],
                                  },
                                  list: {
                                    inDropdown: true,
                                    options: ["unordered", "ordered"],
                                  },
                                  link: {
                                    inDropdown: false,
                                    options: ["link"],
                                  },
                                  blockType: {
                                    inDropdown: false,
                                    options: ["Blockquote"],
                                  },
                                }}
                                handlePastedText={() => false}
                                name="description[0]"
                                editorState={this.state.emailTextValForEditor}
                                onEditorStateChange={(e) => {
                                  var ediData = draftToHtml(
                                    convertToRaw(e.getCurrentContent())
                                  );
                                  var tempDom = $("<output>").append(
                                    $.parseHTML(ediData)
                                  );

                                  let finalval = tempDom.html();
                                  setFieldValue("description", [finalval]);

                                  this.setState({ emailTextValForEditor: e });
                                }}
                                hashtag={{}}
                              />
                            ) : (
                              <Editor
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                                mention={{
                                  separator: " ",
                                  trigger: "@",
                                  suggestions: this.state.AllRefVarForEditor,
                                }}
                                toolbarHidden={true}
                                handlePastedText={() => false}
                                name="description[0]"
                                editorState={
                                  this.state.actualEmailTextValForEditor
                                }
                                disabled
                                onFocus={() => {
                                  if (!this.state.disableAll) {
                                    this.toggleDescription(
                                      values,
                                      setFieldValue,
                                      values.description,
                                      this.state
                                        .editcommunicationDesctription == true
                                        ? "save"
                                        : ""
                                    );
                                  }
                                }}
                                hashtag={{}}
                              />
                            )}
                          </div>
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                        </Col>
                      ) : (
                        <Col xs="12">
                          {this.state.editcommunicationDesctription == true ? (
                            <MentionsInput
                              multiLine
                              name="description"
                              type="textarea"
                              value={
                                values.description ? values.description[0] : ""
                              }
                              className={
                                "font-14 " +
                                (errors.description &&
                                errors.description[0] &&
                                (touched.description && touched.description[0])
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={(e) => {
                                setFieldValue("description", [e.target.value]);
                              }}
                              style={defaultStyle}
                            >
                              <Mention
                                trigger="@"
                                appendSpaceOnAdd={true}
                                data={this.state.AllRefVar}
                                markup="{(__id__)}"
                              />
                            </MentionsInput>
                          ) : (
                            <Field
                              component="textarea"
                              name="description[0]"
                              className="form-control font-14 "
                              rows="4"
                              value={
                                this.state.actualValues.description &&
                                this.state.actualValues.description[0] + ""
                              }
                              disabled={this.state.disableAll}
                              onFocus={() => {
                                this.toggleDescription(
                                  values,
                                  setFieldValue,
                                  values.description,
                                  this.state.editcommunicationDesctription ==
                                    true
                                    ? "save"
                                    : ""
                                );
                              }}
                            />
                          )}
                          {/* </div> */}
                          <ErrorMessage
                            name="description[0]"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                        </Col>
                      )}
                      {this.state.editcommunicationDesctription == true ? (
                        <Col xs="12" className="mt-2">
                          <Button
                            variant="primary"
                            className="btn-blue"
                            onClick={() => {
                              //   if (isActive === "false") {
                              //     toastMessage(
                              //       code.ERROR,
                              //       "Your subscription is not active, Please activate to continue."
                              //     );
                              //   } else {
                              //     this.toggleDescription(
                              //       values,
                              //       setFieldValue,
                              //       values.description,
                              //       this.state.editcommunicationDesctription ==
                              //         true
                              //         ? "save"
                              //         : ""
                              //     );
                              //   }

                              this.toggleDescription(
                                values,
                                setFieldValue,
                                values.description,
                                this.state.editcommunicationDesctription == true
                                  ? "save"
                                  : ""
                              );
                            }}
                          >
                            Save
                          </Button>
                          <Button
                            variant="primary"
                            className="ml-10 btn-blue btn-outlined ml-2"
                            onClick={() => {
                              this.toggleDescription(
                                values,
                                setFieldValue,
                                values.description,
                                this.state.editcommunicationDesctription == true
                                  ? "cancel"
                                  : ""
                              );
                            }}
                          >
                            Cancel
                          </Button>
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                  </div>
                ) : (
                  // task Interactive
                  <div>
                    <Row className="mx-0 mb-2 bg-blue-5 py-2">
                      <Col>
                        {(this.state.userType === message.VENDOR &&
                          this.state.currentRole === message.VENDOR) ||
                        this.state.userType === message.BUYER ? (
                          <label
                            className="font-14 mb-0"
                            style={{ color: "black" }}
                          >
                            Document upload {!values.document && "not"} required
                          </label>
                        ) : (
                          <div className="custom-control custom-checkbox custom-control-inline">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="document"
                              name="document"
                              checked={values.document}
                              disabled={this.state.disableAll}
                              onChange={(e) => {
                                this.updateTask(
                                  values,
                                  setFieldValue,
                                  "document",
                                  e.target.checked
                                );
                              }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="document"
                            >
                              Document upload required
                            </label>
                          </div>
                        )}
                      </Col>
                    </Row>
                    {this.state.actualValues.assigneeData ? (
                      <>
                        {(this.state.userType === message.VENDOR &&
                          this.state.currentRole === message.VENDOR) ||
                        this.state.userType === message.BUYER ? (
                          <div className="assign-var-group">
                            <Row className="user-list mx-0">
                              <Col className="col-auto pr-0">
                                <span className="user-img yellow">
                                  {(
                                    this.state.actualValues.assigneeData
                                      .firstname + ""
                                  ).substring(0, 1)}
                                  {(
                                    (this.state.actualValues.assigneeData
                                      .lastname
                                      ? this.state.actualValues.assigneeData
                                          .lastname
                                      : "") + ""
                                  ).substring(0, 1)}
                                </span>
                              </Col>
                              <Col>
                                <h4 className="user-name">
                                  {this.state.actualValues.assigneeData
                                    .firstname +
                                    (this.state.actualValues.assigneeData
                                      .lastname
                                      ? " " +
                                        this.state.actualValues.assigneeData
                                          .lastname
                                      : "")}
                                </h4>
                                <p className="user-post">
                                  {this.state.actualValues.assigneeData.role}
                                </p>
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          <div className="assign-var-group">
                            <Row className="user-list mx-0">
                              <Col className="col-auto pr-0">
                                <span className="user-img yellow">
                                  {(
                                    this.state.actualValues.assigneeData
                                      .firstname + ""
                                  ).substring(0, 1)}
                                  {(
                                    (this.state.actualValues.assigneeData
                                      .lastname
                                      ? this.state.actualValues.assigneeData
                                          .lastname
                                      : "") + ""
                                  ).substring(0, 1)}
                                </span>
                              </Col>
                              <Col>
                                <h4 className="user-name">
                                  {this.state.actualValues.assigneeData
                                    .firstname +
                                    (this.state.actualValues.assigneeData
                                      .lastname
                                      ? " " +
                                        this.state.actualValues.assigneeData
                                          .lastname
                                      : "")}
                                </h4>
                                <p className="user-post">
                                  {this.state.actualValues.assigneeData.role}
                                </p>
                              </Col>
                            </Row>

                            <Row className="mx-0 mail-row assign-var-row assign-var-row-custom">
                              <Col className="assign-var-select">
                                <ReactSelect
                                  onBlur={handleBlur}
                                  fullWidth
                                  isDisabled={this.state.disableAll}
                                  onChange={(e) => {
                                    this.updateTask(
                                      values,
                                      setFieldValue,
                                      "assignee",
                                      e.value
                                    );
                                  }}
                                  value={{
                                    label: values.assignee,
                                    value: values.assignee,
                                  }}
                                  className="react-select-wrapper react-select-multi"
                                  name="assignee"
                                  options={this.state.assigneeOptions}
                                />

                                <ErrorMessage
                                  name="assignee"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </Col>
                            </Row>
                          </div>
                        )}
                      </>
                    ) : (
                      <Row className="mx-0 mail-row assign-var-row assign-var-row-first">
                        <Col className="col-auto pr-0">
                          <h5 className="font-14 color-blue-4 mb-0">
                            Assign to
                          </h5>
                        </Col>
                        <Col className="assign-var-select">
                          <ReactSelect
                            onBlur={handleBlur}
                            fullWidth
                            isDisabled={this.state.disableAll}
                            onChange={(e) => {
                              this.updateTask(
                                values,
                                setFieldValue,
                                "assignee",
                                e.value
                              );
                            }}
                            value={{
                              label: values.assignee,
                              value: values.assignee,
                            }}
                            className="react-select-wrapper react-select-multi"
                            name="assignee"
                            options={this.state.assigneeOptions}
                          />
                          <ErrorMessage
                            name="assignee"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                        </Col>
                      </Row>
                    )}

                    <hr className="mt-2 mb-2" />
                    <Row className="mx-0 mb-3">
                      <Col>
                        <h5 className="font-14 color-blue-4">Detail</h5>

                        <div className="editor-main">
                          {this.state.editcommunicationDesctription == true ? (
                            <Editor
                              wrapperClassName="demo-wrapper"
                              editorClassName="demo-editor"
                              mention={{
                                separator: " ",
                                trigger: "@",
                                suggestions: this.state.AllRefVarForEditor,
                              }}
                              toolbar={{
                                options: [
                                  "inline",
                                  "list",
                                  "link",
                                  "blockType",
                                ],
                                inline: {
                                  inDropdown: false,
                                  options: ["bold", "italic"],
                                },
                                list: {
                                  inDropdown: true,
                                  options: ["unordered", "ordered"],
                                },
                                link: { inDropdown: false, options: ["link"] },
                                blockType: {
                                  inDropdown: false,
                                  options: ["Blockquote"],
                                },
                              }}
                              handlePastedText={() => false}
                              name="description[0]"
                              editorState={this.state.detailsValForEditor}
                              onEditorStateChange={(e) => {
                                var ediData = draftToHtml(
                                  convertToRaw(e.getCurrentContent())
                                );
                                var tempDom = $("<output>").append(
                                  $.parseHTML(ediData)
                                );

                                let finalval = tempDom.html();
                                setFieldValue("description", [finalval]);

                                this.setState({ detailsValForEditor: e });
                              }}
                              hashtag={{}}
                            />
                          ) : (
                            <Editor
                              wrapperClassName="demo-wrapper"
                              editorClassName="demo-editor"
                              mention={{
                                separator: " ",
                                trigger: "@",
                                suggestions: this.state.AllRefVarForEditor,
                              }}
                              toolbarHidden={true}
                              handlePastedText={() => false}
                              name="description[0]"
                              editorState={
                                this.state.actualEmailTextValForEditor
                              }
                              disabled
                              onFocus={() => {
                                if (!this.state.disableAll) {
                                  this.toggleDescription(
                                    values,
                                    setFieldValue,
                                    values.description,
                                    this.state.editcommunicationDesctription ==
                                      true
                                      ? "save"
                                      : ""
                                  );
                                }
                              }}
                              hashtag={{}}
                            />
                          )}
                        </div>
                        <ErrorMessage
                          name="description"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </Col>
                      {this.state.editcommunicationDesctription == true ? (
                        <Col xs="12" className="mt-2">
                          <Button
                            variant="primary"
                            className="btn-blue"
                            onClick={() => {
                              //   if (isActive === "false") {
                              //     toastMessage(
                              //       code.ERROR,
                              //       "Your subscription is not active, Please activate to continue."
                              //     );
                              //   } else {
                              //     this.toggleDescription(
                              //       values,
                              //       setFieldValue,
                              //       values.description,
                              //       this.state.editcommunicationDesctription ==
                              //         true
                              //         ? "save"
                              //         : ""
                              //     );
                              //   }

                              this.toggleDescription(
                                values,
                                setFieldValue,
                                values.description,
                                this.state.editcommunicationDesctription == true
                                  ? "save"
                                  : ""
                              );
                            }}
                          >
                            Save
                          </Button>
                          <Button
                            variant="primary"
                            className="ml-10 btn-blue btn-outlined ml-2"
                            onClick={() => {
                              this.toggleDescription(
                                values,
                                setFieldValue,
                                values.description,
                                this.state.editcommunicationDesctription == true
                                  ? "cancel"
                                  : ""
                              );
                            }}
                          >
                            Cancel
                          </Button>
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                  </div>
                )}
                <div style={{ backgroundColor: "#f8f8f8", padding: "15px" }}>
                  <Dropzone
                    maxSize={100000000}
                    accept={[
                      "image/*",
                      "application/pdf",
                      "application/msword",
                      ".docx",
                      ".xml",
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    ]}
                    disabled={this.checkTaskDetails()}
                    onDrop={(acceptedFiles) => {
                      this.uploadAttchments(
                        acceptedFiles,
                        values._id,
                        values.transactionId,
                        values
                      );
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div
                          className="dropzone-transaction drop-task"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <AttachFile />
                          <p>
                            <strong>
                              Click or drag and drop to add attachments
                            </strong>
                          </p>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </div>

                <div className="comments-thread mt-0">
                  {_.sortBy(values.documents || [], "modifiedDate")
                    .reverse()
                    .map((doc) => {
                      return (
                        <Row className="user-list mx-0">
                          <Col className="pl-4">
                            <div className="comments-text">
                              {this.getType(doc.name || "") == "image" ||
                              this.getType(doc.name || "") == "pdf" ? (
                                <div
                                  onClick={() => {
                                    this.showPreviewModal(doc.uploadedFileName);
                                  }}
                                >
                                  <h4 className="user-name">{doc.name}</h4>
                                  <p className="user-post">
                                    <em>
                                      by: {doc.firstname} {doc.lastname}{" "}
                                      {moment(doc.modifiedDate).format(
                                        "MM/DD/YYYY - hh:mm a"
                                      )}
                                    </em>
                                  </p>
                                </div>
                              ) : (
                                <a
                                  style={{ right: "40px" }}
                                  href={
                                    UrlConstants.AdminCreateTransactionUrl +
                                    "/upload?id=" +
                                    values.transactionId +
                                    "&img=" +
                                    doc.name
                                  }
                                >
                                  <h4 className="user-name">{doc.name}</h4>
                                  <p className="user-post">
                                    <em>
                                      by: {doc.firstname} {doc.lastname}{" "}
                                      {moment(doc.modifiedDate).format(
                                        "MM/DD/YYYY - hh:mm a"
                                      )}
                                    </em>
                                  </p>
                                </a>
                              )}
                              {this.state.disableAll || !doc.canRemove ? (
                                ""
                              ) : (
                                <Button
                                  style={{ paddingRight: "25px" }}
                                  variant="transparent"
                                  className="comments-delete"
                                  onClick={() =>
                                    this.deletePrompt(doc.folderId)
                                  }
                                >
                                  <DeleteOutline />
                                </Button>
                              )}
                              {this.state.disableAll || !doc.canDelete ? (
                                ""
                              ) : (
                                <Button
                                  variant="transparent"
                                  className="comments-delete"
                                  onClick={() =>
                                    this.archivePrompt(doc.folderId, values)
                                  }
                                >
                                  <ArchiveOutlined />
                                </Button>
                              )}
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                </div>

                {this.state.taskType == false && (
                  <>
                    <hr className="mb-3" />
                    <Row className="user-list mx-0">
                      {!this.state.disableAll && (
                        <Col className="col-auto pr-0">
                          <span className="user-img grey">
                            {localStorage.getItem("fname").substring(0, 1) +
                              localStorage.getItem("lname").substring(0, 1)}
                          </span>
                        </Col>
                      )}
                      <Col>
                        {!this.state.disableAll && (
                          <div>
                            <textarea
                              name=""
                              rows="4"
                              className="form-control"
                              value={this.state.comment}
                              onChange={this.handleChange.bind(this)}
                            />
                            <div className="text-right mt-3">
                              <Button
                                variant="primary"
                                disabled={
                                  (this.state.comment + "").trim() == ""
                                }
                                className="btn-blue btn-outlined font-14"
                                onClick={() => {
                                  //   if (isActive === "false") {
                                  //     toastMessage(
                                  //       code.ERROR,
                                  //       "Your subscription is not active, Please activate to continue."
                                  //     );
                                  //   } else {
                                  //     this.addComment();
                                  //   }

                                  this.addComment();
                                }}
                              >
                                Comment
                              </Button>
                            </div>
                          </div>
                        )}

                        <div className="comments-thread">
                          {_.sortBy(this.state.comments, "modifiedDate")
                            .reverse()
                            .map((com) => {
                              return (
                                <>
                                  <Row className="user-list mx-0">
                                    <Col className="col-auto pr-0">
                                      <span className="user-img yellow">
                                        {(com.firstname
                                          ? com.firstname
                                          : ""
                                        ).substring(0, 1) +
                                          (com.lastname
                                            ? com.lastname
                                            : ""
                                          ).substring(0, 1)}
                                      </span>
                                    </Col>
                                    <Col>
                                      <div className="comments-text">
                                        <h4 className="user-name">
                                          {com.content}
                                        </h4>
                                        <p className="user-post">
                                          <em>
                                            {moment(com.modifiedDate).format(
                                              "MM/DD/YYYY - hh:mm a"
                                            )}
                                          </em>
                                        </p>
                                        {this.state.disableAll ||
                                        (this.state.userType ===
                                          message.VENDOR &&
                                          this.state.currentRole ===
                                            message.VENDOR) ||
                                        this.state.userType ===
                                          message.BUYER ? (
                                          ""
                                        ) : (
                                          <Button
                                            variant="transparent"
                                            className="comments-delete"
                                          >
                                            <DeleteOutline
                                              onClick={() =>
                                                this.setState({
                                                  deleteCommentPrompt: true,
                                                  commentId: com._id,
                                                })
                                              }
                                            />
                                          </Button>
                                        )}
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              );
                            })}
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </Form>
            );
          }}
        </Formik>

        {/* Dependency Modal */}
        <Modal
          show={this.state.DependencyModal}
          onHide={() => this.DependencyModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med1 dependency-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Set Dependency
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SetDependency
              fromTransaction={true}
              transactionData={this.props.transactionData}
              options={this.state.dependencyTasks}
              actiontaken={this.state.actiontaken}
              predecessors={this.state.taskData.predecessorData}
              dependencies={(e) => {
                this.closeModal(e);
                if (
                  this.props.fromTimeline !== undefined &&
                  this.props.fromTimeline
                ) {
                  this.props.reloadPage();
                }
              }}
              eventId={this.state.taskData._id}
            />
          </Modal.Body>
        </Modal>

        {/* Preview */}
        <Modal
          show={this.state.showPreview}
          onHide={() => {
            this.setState({
              showPreview: false,
            });
          }}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-preview"
        >
          <Modal.Header className="d-block">
            <Row className="align-items-center">
              <Col xs="9">
                <div className="modal-title">Document Preview</div>
              </Col>
              <Col xs="3" className="text-right">
                <Button
                  className="close-btn"
                  variant="transparent"
                  onClick={() => {
                    this.setState({
                      showPreview: false,
                    });
                  }}
                >
                  <Close />
                </Button>
              </Col>
            </Row>
          </Modal.Header>
          <Modal.Body>
            {this.getType(this.state.docName || "") == "image" ? (
              <img
                src={
                  UrlConstants.AdminCreateTransactionUrl +
                  "/upload?id=" +
                  this.props.transactionData._id +
                  "&img=" +
                  this.state.docName
                }
              />
            ) : (
              <object
                data={this.state.previewURL || "#"}
                width="100%"
                height="100%"
              />
            )}
          </Modal.Body>
        </Modal>

        {/* Archive Modal */}
        <Modal
          show={this.state.archivePrompt}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            <HelpOutline />
            <p>Are you sure you want to archive?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.archivePrompt();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.archiveDocument(
                  this.state.deleteDocName,
                  this.state.values
                );
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Delete Modal */}
        <Modal
          show={this.state.deletePrompt}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            <HelpOutline />
            <p>Are you sure you want to delete?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.deletePrompt();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.deleteDocument();
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Delete Comment Modal */}
        <DeletePrompt
          deletePrompt={this.state.deleteCommentPrompt}
          itemId={this.state.commentId}
          cancel={() => {
            this.setState({ deleteCommentPrompt: false });
          }}
          deleteConfirm={this.deleteComment}
        />

        {/* Date change confirmation */}
        <Modal
          show={this.state.moveConfirmationModal}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 ">
            <p className="text-center font-16 color-dark-blue">
              Are you sure want to change date of this task?
            </p>
            <div className="px-1">
              <p className="mb-0 font-500 font-14">
                here is the list of task that will be affected :
              </p>
              <ul className="dependency-modal-task-list font-12">
                {this.state.affectedTasks.map((e, i) => {
                  if (e) {
                    return (
                      <li key={e.title}>
                        {moment(e.eventEndDate).format("MM/DD/YYYY ") +
                          getTimeFromMins(e.time)}{" "}
                        - {e.title}
                      </li>
                    );
                  }
                })}
              </ul>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.setState({ moveConfirmationModal: false });
                this.props.onUpdate("update");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.confirmMove();
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Error Modal */}
        <Modal
          show={this.state.moveErrorModal}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0">
            {this.state.moveErrorMessage instanceof Array ? (
              <>
                <p className="text-center font-16 color-dark-blue">
                  Unable to update status of this task as the task(s) on which
                  this task is dependent, are not marked as completed yet.
                </p>
                <div className="px-1">
                  <p className="mb-0 font-500 font-14">
                    Here is the list of task which are not completed.
                  </p>
                  <ul className="dependency-modal-task-list font-12">
                    {this.state.moveErrorMessage.map((e, i) => {
                      if (e) {
                        return (
                          <li key={e.title}>
                            {" "}
                            {moment(e.eventEndDate).format("MM/DD/YYYY ") +
                              getTimeFromMins(e.time)}{" "}
                            - {e.title}
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              </>
            ) : (
              this.state.moveErrorMessage
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.closeErrorModal();
              }}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.isDocumentRequired}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            <HelpOutline />
            <p>Document is required</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.setState({ isDocumentRequired: false });
              }}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Status change confirmation modal */}
        <Modal
          show={this.state.statusChangeShow}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            <p>Are you sure want to mark the task as completed?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.closeStatusChangeModal();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.setState({ statusChangeShow: false });
                if (this.props.transactionData.status == "INPROGRESS") {
                  this.updateTask(
                    this.state.statusVal,
                    this.state.statusFieldVal,
                    "status",
                    this.state.selectedVal
                  );
                }
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    taskData: state.reducer.taskData,
    variablesRefs: state.reducer.variablesRefs,
    dependencyTasks: state.reducer.dependencyTasks,
    specialTask: state.reducer.specialTask,
  };
};

export default connect(
  mapStateToProps,
  {
    getTaskDetailsAction,
    uploadDocumentAction,
    listDocAction,
    getVarriableRefAction,
    updateDocAction,
    getSpecialTaskAction,
    documentNotificationAction,
    updateTaskAction,
    getActualValuesAction,
    addDocAction,
    deleteCommentAction,
    addCommentAction,
    GetDependencytasksAction,
    updateDepedentTaskAction,
    deleteDocFromTaskAction,
    removeDocumentAction,
    getallpermissions,
    getVendorSpecialAppoTasksAction,
  }
)(TaskDetail);
